var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14Z",
  stroke: "currentColor",
  strokeWidth: 2.22222,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 19C13.4477 19 13 18.5523 13 18L13 14C13 13.4477 13.4477 13 14 13C14.5523 13 15 13.4477 15 14L15 18C15 18.5523 14.5523 19 14 19Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 10C13 9.44771 13.4477 9 14 9C14.5523 9 15 9.44771 15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10Z",
  fill: "currentColor"
})));
export { SvgInfoIcon as ReactComponent };